import { render, staticRenderFns } from "./PlanSettingsInitiatives.vue?vue&type=template&id=4f33bf62"
import script from "./PlanSettingsInitiatives.vue?vue&type=script&lang=ts"
export * from "./PlanSettingsInitiatives.vue?vue&type=script&lang=ts"
import style0 from "./PlanSettingsInitiatives.vue?vue&type=style&index=0&id=4f33bf62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports